var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="emptyTableContainer">\n  <div class="emptyPublicTableInfo emptynessInfo">\n    <h4>This dataset is empty</h4>\n    <p>If you are the owner of this dataset remember to login and add your desired rows.</p>\n    <p>If not, you can’t do anything interesting here.</p>\n  </div>\n</div>\n';

}
return __p
}